import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Configuration } from '../app.constants';
import 'rxjs/add/operator/map';
import { ApiResponse } from '../admin/apiresponse';
import { TestGroup } from '../admin/models/testgroup';
import { TestGroupSystemsStatus } from '../admin/models/testgroupsystemsstatus';
import { AdalHttp } from './adal.http.service';

@Injectable()
export class TestGroupService {

    private actionUrl: string;
    private headers: Headers;
    private apiResponse: ApiResponse;

    constructor(private _http: AdalHttp, private _configuration: Configuration) {

        this.actionUrl = _configuration.ServerWithApiUrl + 'testgroup/';

        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json');
    }

    public createTestGroup = (deviceType): Observable<any> => {
        let body = JSON.stringify(deviceType);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });

        return this._http.post(this.actionUrl, body, options)
            .map(this.parseTestGroupCreationResponse);
        //.catch(this.handleError);        
    }

    public updateTestGroup(testGroup: TestGroup): Observable<any> {
        let body = JSON.stringify(testGroup);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this._http.put(this.actionUrl, body, options)
            .map(this.parseTestGroupCreationResponse);
        //.catch(this.handleError);
    }

    public getTestGroupsOfDeviceType(name: string): Observable<any> {
        return this._http.get(this.actionUrl + '/' + name);
        //    .map(this.extractApiResponse)
        //.catch(this.handleError);
    }

    public deleteTestGroup(deviceType: string, testGroupName: string): Observable<any> {
        return this._http.delete(this.actionUrl + '/' + deviceType + '/' + testGroupName);
        //    .map(this.extractApiResponse);
        //.catch(this.handleError);
    }

    public getTestGroupDetails(deviceType: string, testGroupName: string): Observable<any> {
        return this._http.get(this.actionUrl + '/' + deviceType + '/' + testGroupName);
        //    .map(this.extractApiResponse);
        //.catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body.data || {};
    }

    private parseTestGroupCreationResponse(res: any) {
        /* test group creation returns 3 statuses
        1. testGroupCreationResponse,
        2. assetVersionResponse
        3. addSystemsToTestGroupResponse
        */
        let api: { [key: string]: any } = {};

        let apiResponses: ApiResponse[] = [];
        let apiResponseSystems: TestGroupSystemsStatus[] = [];
        let respBody = res.data || {};//.json();
        if (respBody.GroupCreationResponse) {
            let testGroupResponse = TestGroupService.extract(respBody.GroupCreationResponse);
            api['testGroupResponse'] = testGroupResponse;            
        }
        if (respBody.AssetVersionResponse) {
            api['assetResponse'] = TestGroupService.extract(respBody.AssetVersionResponse);
        }
        if (respBody.SystemIdsResponse) {
            for (let r of respBody.SystemIdsResponse) {
                apiResponseSystems.push(TestGroupService.extractSystemsAssignmentStatus(r));
            }
            api['systemResponse'] = apiResponseSystems;// TestGroupService.extract(respBody.systemIdsResponse);
        }
        return api;
    }

    static extract(resp: any): ApiResponse {
        let apiResp = new ApiResponse();
        //let respBody = resp.json();
        if (resp) {
            apiResp.statusCode = resp.Response.StatusCode;
            apiResp.reasonPhrase = resp.Response.ReasonPhrase;
            apiResp.isSuccess = resp.Response.IsSuccessStatusCode;
            apiResp.data = resp.body || [];
        }
        return apiResp;
    }

    static extractSystemsAssignmentStatus(resp: any): TestGroupSystemsStatus {
        let sysResp = new TestGroupSystemsStatus();
        sysResp.systemid = resp.SystemId;
        sysResp.statuscode = resp.StatusCode;
        sysResp.issystemassignedtotestgroup = resp.IsSystemAssignedToTestGroup;
        sysResp.errormessage = resp.ReasonPhrase;
        return sysResp;
    }  

    //private extractApiResponse(res: Response) {

    //    this.apiResponse = new ApiResponse();
    //    let respBody = res.json();
    //    this.apiResponse.statusCode = respBody.response.statusCode;
    //    this.apiResponse.reasonPhrase = respBody.response.reasonPhrase;
    //    this.apiResponse.isSuccess = respBody.response.isSuccessStatusCode;
    //    this.apiResponse.data = respBody.body || [];
    //    return this.apiResponse;
    //}

    //private handleError(error: any) {
    //    let errMsg = (error.message) ? error.message :
    //        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    //    this.apiResponse = new ApiResponse();
    //    this.apiResponse.statusCode = error.status;
    //    this.apiResponse.reasonPhrase = error.statusText;
    //    this.apiResponse.isSuccess = false;

    //    return Observable.throw(this.apiResponse);

    //}
}


// WEBPACK FOOTER //
// ./app/services/testgroup.service.ts